import { API_URL } from "../../helpers/environment";
import { headersJson, headersToken } from "../requestHeaders";

export async function login(payload) {
  return await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: headersJson(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => data);
}

export async function getUserProfile() {
  return await fetch(`${API_URL}/user/me`, {
    method: "POST",
    headers: headersToken(),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.body) {
        let menuPermission = {};
        data.body.moduleTypeList?.forEach(({ name, id: parentId, moduleList }) => {
          let groupPermission = {};
          moduleList?.forEach((item) => {
            const permKey = item.type;
            const isPermitted = item.checked;

            // Map by specific module name
            if (!menuPermission[item.name]) menuPermission[item.name] = {};
            menuPermission[item.name][permKey] = isPermitted;

            // Map by specific module ID (if available)
            if (item.id) {
              if (!menuPermission[item.id]) menuPermission[item.id] = {};
              menuPermission[item.id][permKey] = isPermitted;
            }

            // Keep group-level mapping (parent name/id)
            groupPermission[permKey] = isPermitted;
          });

          if (name) menuPermission[name] = groupPermission;
          if (parentId) menuPermission[parentId] = groupPermission;
        });

        return {
          ...data.body,
          photo: data.body.photo,
          menuPermission: menuPermission,
        };
      }
    });
}

export async function logout() {
  return await fetch(`${API_URL}/auth/logout?deviceId=1`, {
    method: "POST",
    headers: headersToken(),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.header.statusCode === 200 && data.header.result) {
        localStorage.clear();
        return data;
      }
    });
}
